<template>
  <div class="fip-more-informations">
    <h2> {{ $t('fip.more.title') }} </h2>
    <fip-disponibility v-if="item.definitions.length > 0" :definitions="item.definitions" />
    <fip-long-summary v-if="item.longSummary" :text="item.longSummary" />
  </div>
</template>

<script>
import FipLongSummary from '../fipLongSummary/FipLongSummary'
import FipDisponibility from '../fipDisponibility/FipDisponibility'
export default {
  name: 'FipMore',
  components: {
    FipDisponibility,
    FipLongSummary
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fip-more-informations {
  max-width: 1280px;
  margin: auto;
  @include mediaQueries('padding', (xsmall: 15px 15px, medium: 20px 27px, large: 24px 53px));
}
</style>
